export interface TourStepConfig {
  id: string;
  selector: string;
  content: string;
  route?: string;
  waitFor?: string;
  onNext?: () => void;
}

export const tourSteps: TourStepConfig[] = [
  {
    id: "project-top",
    selector: '[data-tour-id="tutorial-project-top"]',
    content:
      "こちらがプロジェクトトップです。ダッシュボード、詳細情報、メンバー、ナレッジのタブで構成されています。実際にサンプルプロジェクトの使い方を体験してみましょう。",
    route: "/tutorial/project-top",
    waitFor: '[data-tour-id="tutorial-project-top"]',
  },
  {
    id: "sidebar-overview",
    selector: '[data-tour-id="tutorial-sidebar"]',
    content:
      "左側のサイドバーから、生成したドキュメントの詳細ページにアクセスしたり、プロジェクトを切り替えることができます。",
    route: "/tutorial/project-top",
    waitFor: '[data-tour-id="tutorial-sidebar"]',
  },
  {
    id: "dashboard-explanation",
    selector: '[data-tour-id="dashboard-main"]',
    content:
      "こちらがドキュメントの生成フローです。STEP1からSTEP4まで順番に進めると、議事録から基本設計までを自動生成できます。各ドキュメントを生成する際に、クレジットが消費されます。",
    route: "/tutorial/project-top",
  },
  {
    id: "dashboard-upload",
    selector: '[data-tour-id="dashboard-step1"]',
    content:
      "まず、STEP1で文字起こしまたは議事録をアップロードします。議事録は、システムの要件を自動抽出するための重要な情報源となります。「生成」ボタンをクリックしてみましょう。（クレジットは消費されません）",
    route: "/tutorial/project-top",
    waitFor: '[data-tour-id="dashboard-step1"]',
  },
  {
    id: "summary",
    selector: '[data-tour-id="summary-content"]',
    content:
      "こちらが生成された議事録です。会議の内容が構造化されて表示され、後続のドキュメント生成に活用できます。必要に応じて編集や共有も可能です。",
    route: "/tutorial/summary",
    waitFor: '[data-tour-id="summary-content"]',
  },
  {
    id: "knowledge",
    selector: '[data-tour-id="knowledge-content"]',
    content:
      "ナレッジページでは、文字起こしやAIチャットで得た、自社の開発ルールや決まった項目を抽出したり知見や思考を蓄積できます。ドキュメント種別ごとに整理されるため、必要な情報をすぐに参照できます。手動で追加することも可能です。",
    route: "/tutorial/knowledge",
    waitFor: '[data-tour-id="knowledge-content"]',
  },
  {
    id: "generate-system-proposal",
    selector: '[data-tour-id="generate-system-proposal"]',
    content:
      "次に、STEP2でシステム概要書を生成します。議事録とナレッジをもとに、システムのアーキテクチャや機能要件が自動で整理されます。「生成」ボタンをクリックしてみましょう。（クレジットは消費されません）",
    route: "/tutorial/project-top",
    waitFor: '[data-tour-id="generate-system-proposal"]',
  },
  {
    id: "system-proposal",
    selector: '[data-tour-id="system-proposal-content"]',
    content:
      "こちらが生成されたシステム概要書です。このドキュメントによって、プロジェクトの全体像を把握することができます。",
    route: "/tutorial/system-proposal",
    waitFor: '[data-tour-id="system-proposal-content"]',
  },
  {
    id: "ai-chat",
    selector: '[data-tour-id="ai-chat-content"]',
    content:
      "AIチャットでは、生成したドキュメントに関する質問や追記依頼をAIに相談できます。これでチュートリアルは完了です。",
    route: "/tutorial/ai-chat",
    waitFor: '[data-tour-id="ai-chat-content"]',
  },
];
